import { Component, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { ReportService } from '@app/_components/report';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { first } from 'rxjs/operators';
import { MatMenuItem as MatMenuItem } from '@angular/material/menu';
import { RateBucketService } from '@app/_components/rate/rate-bucket';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, ConstantService } from '@app/_services';
import { FeaturesService } from '@app/_components/feature/features.service';

@Component({
    selector: 'app-feature-admin-container',
    templateUrl: './feature-admin-container.component.html',
    styleUrls: ['./feature-admin-container.component.css'],
    standalone: false
})
export class FeatureAdminContainerComponent implements OnInit {

	@Output() doSearchCB = new EventEmitter<any>();

	selectedLocationIds: any = [];
	selectedShortTermRentalIds: any = [];
	selectedDevelopmentIds: any = [];
	selectedRateBucketIds: any = [];
	selectedBedrooms: any = [];
	selectedSeasons: any = [];
	selectedStartDate: any;
	selectedEndDate: any;
	rateBuckets: any;
	shortTermRentals: any;
	developments: any;
	
	bedrooms = [
		{ id: 0, name: 'Studio' },
		{ id: 1, name: '1 Bd' },
		{ id: 2, name: '2 Bd' },
		{ id: 3, name: '3 Bd' },
		{ id: 4, name: '4 Bd' },
		{ id: 5, name: '5 Bd' },
		{ id: 6, name: '6 Bd' },
		{ id: 7, name: '7 Bd' },
		{ id: 8, name: '8 Bd' },
		{ id: 9, name: '9 Bd' },
		{ id: 10, name: '10 Bd' },
	];
	
	highlights = [
		{ value: '', name: 'None' },
		{ value: 1, name: 'Details' },
		{ value: 2, name: 'Details + Summary' },
		{ value: 3, name: 'Details + Summary + Search Result' },
	];
	
	distanceUnits = [
		{ name: 'Feet', value: 'FT' },
		{ name: 'Miles', value: 'MI' },
		{ name: 'Meters', value: 'M' },
		{ name: 'Kilometers', value: 'KM' },
		{ name: 'Minutes', value: 'MIN' },
	];

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formToSubmit: any;
	featureId: any;
	feature: any;
	actionLabel: any;
	formTitle: any;

validationMessages = {
			formLocationIds: [],
			formShortTermRentalIds: [],
			formDevelopmentIds: [],
			formRateBucketIds: [],
			formBedrooms: [],
			formSeasons: [],
			formStartDate: [],
			formEndDate: [],
			
			
			newFeatureName: [],
			newFeatureDesc: [],
			newHighlight: [],
			newDescribesType: [],
			newQuantity: [],
			newDistance: [],
			newDistanceUnit: [],
	};
	locations: any[];

	constructor(private reportService: ReportService,
		private messageService: MessageService,
		private constantService: ConstantService,
		private confirmationService: ConfirmationService,
		private rateBucketService: RateBucketService,
		public formBuilder: UntypedFormBuilder,
		public alertService: AlertService,
		private featureService: FeaturesService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.feature = data.feature
		this.locations = constantService.locations;
	}

	ngAfterViewInit(): void {
	}


	ngOnInit(): void {
		console.log("this.feature : " + JSON.stringify(this.feature));

		this.loadShortTermRentals();
		this.loadDevelopments();
		this.loadRateBuckets();
		this.formBuild();

		// patch in the default name and desc
		this.form1.controls['newFeatureName'].patchValue(this.feature.name);
		this.form1.controls['newFeatureDesc'].patchValue(this.feature.featureDesc);
		this.form1.controls['newHighlight'].patchValue(this.feature.defaultHighlight);

		this.actionLabel = 'Copy ' + this.feature.name;
	}

	ngOnChanges(changes: SimpleChanges): void {
	}


	/*
	 *
	 *SEARCH FORM - TO PUT INTO COMPONENT
	 *
	 */

	copyFeatureClick() {
		this.buildSearchForm();
		console.log(this.form1.value);
		console.log(JSON.stringify(this.formToSubmit));
		this.doSearchCB.emit(this.formToSubmit);
		this.copyFeature();
		return;
	}

	copyFeature() {
		try {
			// stop here if form is invalid

			// create the propertyFeature
			this.feature.name = this.form1.get('newFeatureName').value;
			this.feature.featureDesc = this.form1.get('newFeatureDesc').value;
			this.feature.highlight = this.form1.get('newHighlight').value;
			this.feature.quantity = this.form1.get('newQuantity').value;
			this.feature.distance = this.form1.get('newDistance').value;
			this.feature.distanceUnit = this.form1.get('newDistanceUnit').value;


			// create the reportSearch
			let reportSearch = {
				locationIdList: this.selectedLocationIds,
				developmentIdList: this.selectedDevelopmentIds,
				shortTermRentalIdList: this.selectedShortTermRentalIds,
				bedroomList: this.selectedBedrooms,
			}

			let payload = {
				propertyFeature: this.feature,
				reportSearch: reportSearch,
			};

			this.formLoading = true;
			this.featureService.copySingleFeatureToShortTermRentals(payload)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('feature-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
						this.formLoading = false;
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}


	formBuild() {
		this.form1 = this.formBuilder.group({
			formLocationIds: [],
			formShortTermRentalIds: [],
			formDevelopmentIds: [],
			formRateBucketIds: [],
			formBedrooms: [],
			formSeasons: [],
			formStartDate: [],
			formEndDate: [],
		
			newFeatureName: [],
			newFeatureDesc: [],
			newHighlight: [],
			newDescribesType: [],
			newQuantity: [],
			newDistance: [],
			newDistanceUnit: [],
		});
	}

	buildSearchForm() {
		this.formToSubmit = {};

		// locationIds
		this.selectedLocationIds = [];
		if (this.form1.get('formLocationIds').value) {
			this.form1.get('formLocationIds').value.forEach(element => {
				this.selectedLocationIds.push(element.locationId);
			});
			this.formToSubmit.locationIdList = this.selectedLocationIds;
		}


		// developmentIds
		this.selectedDevelopmentIds = [];
		if (this.form1.get('formDevelopmentIds').value) {
			this.form1.get('formDevelopmentIds').value.forEach(element => {
				this.selectedDevelopmentIds.push(element.developmentId);
			});
			this.formToSubmit.developmentIdList = this.selectedDevelopmentIds;
		}

		// shortTermRentalIds
		this.selectedShortTermRentalIds = [];
		if (this.form1.get('formShortTermRentalIds').value) {
			this.form1.get('formShortTermRentalIds').value.forEach(element => {
				this.selectedShortTermRentalIds.push(element.shortTermRentalId);
			});
			this.formToSubmit.shortTermRentalIdList = this.selectedShortTermRentalIds;
		}

		// seasons
		this.selectedSeasons = [];
		if (this.form1.get('formSeasons').value) {
			this.form1.get('formSeasons').value.forEach(element => {
				this.selectedSeasons.push(element.id);
			});
			this.formToSubmit.seasonList = this.selectedSeasons;
		}

		// bedrooms
		this.selectedBedrooms = [];
		if (this.form1.get('formBedrooms').value) {
			this.form1.get('formBedrooms').value.forEach(element => {
				this.selectedBedrooms.push(element.id);
			});
			this.formToSubmit.bedroomList = this.selectedBedrooms;
		}

		// rateBucketIds
		this.selectedRateBucketIds = [];
		if (this.form1.get('formRateBucketIds').value) {
			this.form1.get('formRateBucketIds').value.forEach(element => {
				this.selectedRateBucketIds.push(element.rateBucketId);
			});
			this.formToSubmit.rateBucketIdList = this.selectedRateBucketIds;
		}

		// start date
		if (this.form1.get('formStartDate').value) {
			this.selectedStartDate = this.form1.get('formStartDate').value;
			this.formToSubmit.startDate = this.selectedStartDate;
		}

		// end date
		if (this.form1.get('formEndDate').value) {
			this.selectedEndDate = this.form1.get('formEndDate').value;
			this.formToSubmit.endDate = this.selectedEndDate;
		}
	}

	loadShortTermRentals() {
		this.formLoading = true;
		this.reportService.propertySummaryList().pipe(first()).subscribe(

			data => {
				this.shortTermRentals = data.data.propertySummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}

	loadDevelopments() {
		this.formLoading = true;
		this.reportService.developmentSummaryList().pipe(first()).subscribe(

			data => {
				this.developments = data.data.developmentSummaryList;
			},
			error => {
				console.log('reports LIST!: ' + JSON.stringify(error));
				this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
			},
			() => { this.formLoading = false; }
		);
	}
	loadRateBuckets() {
		try {
			this.rateBucketService.findAll()
				.subscribe(
					res => {
						this.rateBuckets = res.data.rateBuckets;
					},
					err => {
						console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: err.message, life: 3000 });
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.messageService.add({ severity: 'error', summary: error.message, life: 3000 });
		}
	}
	
		getDistanceUnitName(value: any) {
		let result = this.distanceUnits.find(x => x.value === value).name;
		if (result) { return result; }
		return '';
	}
}
